






























import { defineComponent } from '@vue/composition-api';
export default defineComponent({
    setup(props, { emit }) {
        function clickUninterested() {
            emit('more-option', 'uninterested');
        }
        function clickReport() {
            emit('more-option', 'report');
        }
        return {
            clickUninterested,
            clickReport,
        };
    },
});
